import { motion } from "framer-motion";
import { Clock, MapPin, Navigation } from "lucide-react";

const HOURS = [
  ["Segunda a sexta", "10:00 — 18:00"],
  ["Sábado", "09:30 — 14:00"],
  ["Domingo", "Fechado"],
];

const ADDRESS = "R. Barão do Triunfo, 208 — Bela Vista, Jundiaí/SP";
const MAPS_DIR = "https://www.google.com/maps/dir/?api=1&destination=R.+Bar%C3%A3o+do+Triunfo,+208,+Bela+Vista,+Jundia%C3%AD+-+SP,+13207-770";
const MAP_EMBED = "https://www.google.com/maps?q=R.+Bar%C3%A3o+do+Triunfo,+208,+Bela+Vista,+Jundia%C3%AD+-+SP,+13207-770&output=embed";

export const Location = () => (
  <section id="localizacao" className="bg-white text-[#0A0A0A] py-24 lg:py-32 px-6" data-testid="location-section">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-stretch">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="lg:col-span-5 flex flex-col"
      >
        <p className="text-xs tracking-[0.3em] font-bold text-[#E60000] mb-3">VISITE O ESTÚDIO</p>
        <h2 className="font-display font-bold text-4xl md:text-5xl leading-none">
          No coração de <span className="italic text-[#E60000]">Jundiaí</span>
        </h2>

        <div className="mt-10 flex items-start gap-4" data-testid="location-address">
          <MapPin size={20} className="text-[#E60000] shrink-0 mt-1" />
          <div>
            <p className="font-extrabold tracking-tight">{ADDRESS}</p>
            <p className="text-sm text-[#0A0A0A]/60 mt-1">CEP 13207-770</p>
          </div>
        </div>

        <div className="mt-10 border-t border-black/10" data-testid="location-hours">
          {HOURS.map(([day, time]) => (
            <div key={day} className="flex items-center justify-between py-4 border-b border-black/10">
              <span className="flex items-center gap-3 text-sm font-semibold">
                <Clock size={14} className="text-[#E60000]" /> {day}
              </span>
              <span className={`text-sm font-bold ${time === "Fechado" ? "text-[#E60000]" : ""}`}>{time}</span>
            </div>
          ))}
        </div>

        <a
          href={MAPS_DIR}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="location-directions-button"
          className="btn-sharp mt-10 inline-flex w-fit items-center gap-2 bg-[#0A0A0A] hover:bg-[#E60000] text-white text-xs tracking-[0.15em] font-extrabold px-8 py-4 transition-colors duration-300"
        >
          <Navigation size={14} /> TRAÇAR ROTA
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="lg:col-span-7 border border-black/10 min-h-[420px]"
        data-testid="location-map-frame"
      >
        <iframe
          title="Mapa — Diggy Shop, R. Barão do Triunfo 208, Jundiaí"
          src={MAP_EMBED}
          className="w-full h-full min-h-[420px] grayscale contrast-[1.05]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          data-testid="location-map"
        />
      </motion.div>
    </div>
  </section>
);
